import {ShippingAddressCommand} from '@domain/model/Account/Address/domain/model/ShippingAddress/ShippingAddressCommand';
import {ShippingAddressRepository} from '@domain/model/Account/Address/domain/model/ShippingAddress/ShippingAddressRepository';

const SetShippingAddress =
  (
    shippingAddressRepository: ShippingAddressRepository,
  ): ((shippingAddress: ShippingAddressCommand) => Promise<Record<string, boolean> | null>) =>
  (shippingAddress: ShippingAddressCommand): Promise<Record<string, boolean> | null> => {
    const {name, lastName, address, postCode, city, phone} = shippingAddress || {};
    if (!name || !lastName || !address || !postCode || !city || !phone) {
      return Promise.resolve(null);
    }

    return shippingAddressRepository.setShippingAddress(shippingAddress);
  };

export {SetShippingAddress};
